import { encodeDataPush, hash256, bigIntToVmNumber, CashAddressNetworkPrefix, hexToBin, lockingBytecodeToCashAddress } from "@bitauth/libauth";
export class Coupon {
    amount;
    lock;
    static unlockingScript = "00cc00c694a16900c788c08bc39c";
    /**
     * Return the address for a Coupon
     *
     *
     * @param amount - the threshold amount (sats) to redeem coupon
     * @param lock - the vault locking bytecode
     * @param network - the network prefix
     */
    static getAddress(amount, lock, network = CashAddressNetworkPrefix.mainnet) {
        let lockingBytecode = this.getLockingBytecode(amount, lock);
        let addr = lockingBytecodeToCashAddress(lockingBytecode, network, { tokenSupport: true });
        if (typeof addr !== 'string')
            throw (addr);
        return addr;
    }
    /**
     * Return the unlockingBytecode for a Coupon
     *
     *
     * @param amount - the threshold amount (sats) to redeem coupon
     * @param lock - the vault locking bytecode
     */
    static getUnlockingBytecode(amount, lock) {
        const amountVm = encodeDataPush(bigIntToVmNumber(BigInt(amount)));
        const lockVm = encodeDataPush(lock);
        const unlockingScript = hexToBin(this.unlockingScript);
        return new Uint8Array([
            ...lockVm,
            ...amountVm,
            ...unlockingScript
        ]);
    }
    /**
     * Return the lockingBytecode for a Coupon
     *
     *
     * @param amount - the threshold amount (sats) to redeem coupon
     * @param lock - the Vault locking bytecode
     */
    static getLockingBytecode(amount, lock) {
        return new Uint8Array([
            ...hexToBin("aa20"),
            ...hash256(this.getUnlockingBytecode(amount, lock)),
            ...hexToBin("87")
        ]);
    }
    static asInput(amount, lock, utxo) {
        return {
            outpointIndex: utxo.vout,
            outpointTransactionHash: hexToBin(utxo.txid),
            sequenceNumber: 0,
            unlockingBytecode: this.getUnlockingBytecode(amount, lock),
        };
    }
}
//# sourceMappingURL=coupon.js.map